/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface UrlDTO
 */
export interface UrlDTO  {
    /**
     * 
     * @type {number}
     * @memberof UrlDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UrlDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UrlDTO
     */
    url?: string;
}

/**
 * Check if a given object implements the UrlDTO interface.
 */
export function instanceOfUrlDTO(value: object): value is UrlDTO {
    return true;
}

export function UrlDTOFromJSON(json: any): UrlDTO {
    return UrlDTOFromJSONTyped(json, false);
}

export function UrlDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UrlDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'type': json['type'] == null ? undefined : json['type'],
                  'url': json['url'] == null ? undefined : json['url'],
    };
}

export function UrlDTOToJSON(json: any): UrlDTO {
    return UrlDTOToJSONTyped(json, false);
}

export function UrlDTOToJSONTyped(value?: UrlDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'url': value['url'],
    };
}


